<template>
    <v-snackbar
        v-model="snack"
        @input="clear"
        :timeout="time"
        rounded="pill"
        :light="error"
        :right="right"
        :app="app"
        :min-width="maxWidth ? '90%' : null"
        :max-width="maxWidth"
    >
        {{ text }}

        <template v-slot:action="{ attrs }">
            <v-btn
                :color="error ? 'error' : 'primary'"
                text
                v-bind="attrs"
                @click="snack = false"
            >
                Close
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    name: "SoliSnack",
    data: function () {
        return {
            snack: true, //this.text ? true : false
        };
    },
    props: {
        text: {
            type: String,
        },
        time: {
            type: Number,
            default: 6000,
        },
        error: {
            type: Boolean,
            default: false,
        },
        right: {
            type: Boolean,
            default: false,
        },
        app: {
            type: Boolean,
            default: true,
        },
        maxWidth: {
            type: [Number, String],
            default: null,
        },
    },
    methods: {
        clear() {
            setTimeout(() => {
                this.$page.props.successMessage = null;
                this.$emit("hide");
                this.snack = false;
            }, 500);
        },
    },
};
</script>
